import styles from "./styles.module.scss";
import { FC, Props } from "./typings";
import { EClientData } from "dto/IClient";
import ClientData from "components/ClientData";
import EmailIcon from "assets/icons/email.svg?react";
import PhoneIcon from "assets/icons/phone.svg?react";
import SenderIcon from "assets/icons/new-outcoming.svg?react";
import CreditIcon from "assets/icons/credit_card.svg?react";
import InfoIcon from "assets/icons/info.svg?react";
import AddressIcon from "assets/icons/location.svg?react";
import { useTranslation } from "react-i18next";

export interface ClientEditTypes {
  label: string;
  Icon: any;
  type: EClientData;
}

const ClientEditData: FC<Props> = ({ client }) => {
  const { t } = useTranslation();

  const types: ClientEditTypes[] = [
    { Icon: EmailIcon, label: t("auth.email"), type: EClientData.EMAIL },
    { Icon: PhoneIcon, label: t("forms.phone"), type: EClientData.PHONE },
    { Icon: SenderIcon, label: t("forms.eDelivery"), type: EClientData.eaddress },
    { Icon: CreditIcon, label: t("forms.accountNumber"), type: EClientData.bank },
    { Icon: AddressIcon, label: t("forms.address"), type: EClientData.ADDRESS },
    { Icon: InfoIcon, label: "REGON", type: EClientData.regon },
  ];

  return (
    <div className={styles.wrapper}>
      {types.map((type) => (
        <ClientData client={client} type={type} key={type.label} />
      ))}
    </div>
  );
};

export default ClientEditData;
